export const SMALL_FEE_HASH = '#how-much-do-i-have-to-pay';
